import React, {useState} from 'react';
import Select from "./inputs/Select";
import TextArea from "./inputs/TextArea";
import BasicInput from "./inputs/BasicInput";
import Label from "./inputs/Label";
import Switch from "./inputs/Switch";
import SearchableSelect from "./inputs/SearchableSelect";
import DateInput from "./inputs/DateInput";
import SingleFileUploader from "../single-file-uploader/SingleFileUploader";
import PostcodeInput from "./inputs/PostcodeInput";

const Input = (props) => {
    const {
        name,
        label       = null,
        value       = "",
        type        = null,
        required    = false,
        error       = null,
        copyEnabled = false,
        disabled    = false,
        onChange    = () => {},
    } = props;

    const [copied, setCopied]   = useState(false);

    const handleCopy = async () => {
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard api method'
            await navigator.clipboard.writeText(value);
        } else {
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = value;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            document.execCommand('copy');
            textArea.remove();
        }

        setCopied(true);
    }

    let inputComponent = null;
    if (!!type && type === "select") {
        inputComponent = <Select {...props} />
    } else if (!!type && type === "searchable-select") {
        inputComponent = <SearchableSelect {...props} />
    } else if (!!type && type === "textarea") {
        inputComponent = <TextArea {...props} />
    } else if (!!type && type === "switch") {
        inputComponent = <Switch {...props} />
    } else if (!!type && type === "date") {
        inputComponent = <DateInput {...props} />
    } else if (!!type && type === "file") {
        inputComponent = <SingleFileUploader {...props} />
    } else if (!!type && type === "postcode") {
        inputComponent = <PostcodeInput {...props} />
    } else {
        inputComponent = (
            <BasicInput
                name={name}
                value={props.value}
                onChange={(value) => onChange(value)}
                type={!!props.type ? props.type : "text"}
                min={!!props.min ? props.min : null}
                max={!!props.max ? props.max : null}
                step={!!props.step ? props.step : null}
                required={!!props.required ? props.required : false}
                autocomplete={!!props.autocomplete ? props.autocomplete : null}
                disabled={!!props.disabled ? props.disabled : false}
                error={!!props.error ? props.error : null}
            />
        );
    }

    return (
        <div className={disabled ? "form-group" : "form-group"}>
            {!!label && (
                <Label
                    label={label}
                    htmlFor={name}
                    required={required}
                />
            )}
            <div className={!!copyEnabled ? "d-flex align-items-center position-relative" : "position-relative"}>
                {inputComponent}
            </div>
            {error !== true && error !== false && (
                <span className="invalid-feedback d-block" role="alert">
                    <strong>{error}</strong>
                </span>
            )}
        </div>
    )
}

export default Input;
